import React from 'react';

const Home = () => (
  <div>
    <h1>Welcome to our page</h1>
    <p>
      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Provident
      explicabo aperiam ipsa itaque quam placeat optio a vero doloremque et,
      ex consequatur ipsum eum quis dicta distinctio iste quidem hic tempore
      eius, voluptatum suscipit tenetur repudiandae! Dolorem ex sint ducimus
      omnis similique aperiam harum eos praesentium dolore explicabo? Quam
      maxime sed animi nulla sapiente temporibus sunt deleniti, explicabo
      obcaecati necessitatibus corrupti fugit magnam optio error recusandae
      praesentium voluptates ut laborum eum sint facilis aliquam possimus id?
      Omnis repellat non a fugit minus, corrupti dolore quisquam beatae
      molestias laborum necessitatibus veritatis.
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Provident
      explicabo aperiam ipsa itaque quam placeat optio a vero doloremque et,
      ex consequatur ipsum eum quis dicta distinctio iste quidem hic tempore
      eius, voluptatum suscipit tenetur repudiandae! Dolorem ex sint ducimus
      omnis similique aperiam harum eos praesentium dolore explicabo? Quam
      maxime sed animi nulla sapiente temporibus sunt deleniti, explicabo
      obcaecati necessitatibus corrupti fugit magnam optio error recusandae
      praesentium voluptates ut laborum eum sint facilis aliquam possimus id?
      Omnis repellat non a fugit minus, corrupti dolore quisquam beatae
      molestias laborum necessitatibus veritatis.
    </p>
  </div>
);

export default Home;
